// TrainingProviderCompanyConfiguration.js

import React, { useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

function CompanyConfiguration() {
  const navigate = useNavigate();

  const [company, setCompany] = useState({
    name: '',
    address: '',
    contactInformation: '',
    companyType: 'internal'
  });
  const { id } = useParams();  // Get company ID from the URL for editing
  const [isEditing, setIsEditing] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (id) {

      console.log('company id:', id);

      // If the ID exists, fetch the company details for editing
      setIsEditing(true);
      fetch(`${API_BASE_URL}/companies/get_companies.php?id=${id}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        // Handle empty or invalid JSON responses gracefully
        return response.text().then(text => {
          try {
            return JSON.parse(text);
          } catch (error) {
            console.log('text:', text);
            throw new Error('Invalid JSON response');
          }
        });
      })
        .then(data => {
          console.log('data:', data);
          setCompany({
            name: data.name || '',
          address: data.address || '',
          contactInformation: data.contact_info || '',
          companyType: data.company_type || 'internal'

          });
          console.log('company:', company);
        })
        .catch(error => console.error('Error fetching company:', error));
    }
  }, [id]);


  const handleChange = e => {
    const { name, value } = e.target;
    setCompany(prevCompany => ({
      ...prevCompany,
      [name]: value
    }));
  };

  const handleSave = () => {

    const form = document.querySelector('form');  // Select the form element
    if (!form.checkValidity()) {
      Swal.fire({ icon: 'warning', text: 'Please fill in all required fields.' });
      return;
    }
    const formData = new FormData();
    formData.append('name', company.name);
    formData.append('address', company.address);
    formData.append('contactInformation', company.contactInformation);
    formData.append('companyType', company.companyType);
    if (isEditing) {
      formData.append('id', id);
      formData.append('isUpdate', 1);
    }
    console.log('Company data:', company);
    console.log('FormData content:', [...formData.entries()]);

    fetch(`${API_BASE_URL}/companies/save_company.php`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        // Handle empty or invalid JSON responses gracefully
        return response.text().then(text => {
          try {
            return JSON.parse(text);
          } catch (error) {
            console.log('text:', text);
            throw new Error('Invalid JSON response');
          }
        });
      })
      .then(data => {
        console.log('Data:', data);
        if (data.success) {
          navigate('/config/company-list');
        } else {
          Swal.fire({ icon: 'error', text: 'Failed to save company: ' + data.message });
        }
      })
      .catch(error => {
        console.error('Error:', error);
        Swal.fire({ icon: 'error', text: 'An error occurred: ' + error.message });
      });
  }; 

  const handleCancel = () => {
    // Redirect back to the admin dashboard without saving
    navigate('/config/company-list');
  };

  return (
    <div className='m-2'>
      <h2>Company Configuration</h2>
      <Form>
        <Form.Group controlId="name">
          <Form.Label>Company Name</Form.Label>
          <Form.Control type="text" name="name" value={company.name} onChange={handleChange} required/>
        </Form.Group>
        <Form.Group controlId="address">
          <Form.Label>Address</Form.Label>
          <Form.Control as="textarea" rows={3} name="address" value={company.address} onChange={handleChange} />
        </Form.Group>
        <Form.Group controlId="contactInformation">
          <Form.Label>Contact Information </Form.Label>
          <Form.Control as="textarea" rows={3} name="contactInformation" value={company.contactInformation} onChange={handleChange} />
        </Form.Group>
        <Form.Group controlId="companyType">
          <Form.Label>Type</Form.Label>
          <Form.Control as="select" name="companyType" value={company.companyType} onChange={handleChange}>
            <option value="internal">Internal (client company)</option>
            <option value="external">External (training vendor)</option>
          </Form.Control>
        </Form.Group>
      </Form>
      <div className='mt-2'>
      <Button variant="primary" className="mr-2" onClick={handleSave}>Save</Button>
      <Button variant="secondary" onClick={handleCancel}>Cancel</Button>
      </div>
    </div>
  );
}

export default CompanyConfiguration;
